import type { Params } from 'react-router-dom';
import type { PayHubDomainSessionsEnumsPlatformType } from 'store/models';
import {
  autoReinit,
  getMerchantRedirectUrl,
  getMerchantUrl,
  inIframe,
  PAGE_STATUS,
  parseBooleanParam,
  parseQuery,
  processUrl,
  softLocalStorageGet,
  urlFormer,
} from 'utils';

interface OnReloadButtonClickHandlerProps {
  platform: PayHubDomainSessionsEnumsPlatformType;
  merchantSuccessUrl?: string;
  merchantFailUrl?: string;
  merchantProcessingUrl?: string;
  merchantRedirectUrlFromState?: string;
  merchantUrl?: string;
}

export const onReloadButtonClickHandler = (props: OnReloadButtonClickHandlerProps) => {
  const {
    platform,
    merchantSuccessUrl,
    merchantFailUrl,
    merchantProcessingUrl,
    merchantRedirectUrlFromState,
    merchantUrl,
  } = props;
  const isPlatformNative: boolean | null = platform ? platform.includes('native') : null;
  const isInIframe = inIframe();
  const params = parseQuery(window.location.search) as Params;
  const { isApplePayAvailable, isGpayAvailable } = params;

  const isGooglePayAvailability: boolean = parseBooleanParam(isGpayAvailable);
  const isApplePayAvailability: boolean = parseBooleanParam(isApplePayAvailable);
  const nativeUrl = getMerchantUrl(merchantUrl) || '';

  const isNativeDevice: boolean =
    (isApplePayAvailability && !isInIframe) || (isGooglePayAvailability && !isInIframe) || !!isPlatformNative;

  if (!isInIframe && !isNativeDevice) {
    const merchantRedirectUrl = getMerchantRedirectUrl({
      merchantRedirectUrlFromState: merchantUrl || merchantRedirectUrlFromState,
      merchantSuccessUrl,
      merchantFailUrl,
      merchantProcessingUrl,
    });
    const merchantRedirectType = softLocalStorageGet('merchant_redirect_type');
    const decodedUrl = merchantRedirectUrl ? decodeURI(merchantRedirectUrl) : false;
    const replaceURL = decodedUrl || urlFormer(merchantUrl, PAGE_STATUS.error);

    if (typeof merchantRedirectType === 'string' && merchantRedirectType?.toLowerCase() === 'blank' && decodedUrl) {
      window.open(replaceURL, '_blank', 'noopener,noreferrer');
    } else if (replaceURL) {
      window.location.assign(replaceURL);
    }

    return;
  }

  autoReinit({
    isSubmitted: true,
    isNativeDevice,
    merchantUrl: processUrl(nativeUrl),
  });
};
